// File: cgp-user-profile-dialog-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile component.
// Other Contributors:

import { Component, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserProfileService } from '../../components/mesc/mesc.service';

@Component({
    selector: "cgp-app-bar-dialog",
    templateUrl: "./cgp-user-profile-dialog.template.html"
})
export class CgpUserProfileDialogComponent {

    @Input() title = 'User Profile';
    @Input() closeLabel = 'Close';
    moduleGroups: any[] = [];
    moduleName: string;
    groupDisplayName: string;
    adminGroups: any[] = [];
    moduleNames: any[] = [];
    Name: string;
    GMIN: string;
    ModuleDetail: any[] = [];
    ModuleClaims: any[];
    RoleClaims: any[];

    isImpersonate: boolean;

    constructor(
        public dialogRef: MatDialogRef<CgpUserProfileDialogComponent>,
        public userProfileService: UserProfileService,
    ) {
        userProfileService.subscribe(data => {
            data['ModuleClaims'].forEach(element => {
                this.ModuleDetail.push({
                    moduleName: element,
                    roles: []
                });
            });
            data['RoleClaims'].forEach(element => {
                const split = element.split(':', 2);
                this.ModuleDetail.forEach(element => {
                    if (element.moduleName == split[0]) {
                        element.roles.push(split[1])
                        element.roles.sort();
                    }
                });
            });
        });
    }
}

